import { render, staticRenderFns } from "./RequestResetPasswordPage.vue?vue&type=template&id=716d7728&scoped=true"
import script from "./RequestResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./RequestResetPasswordPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716d7728",
  null
  
)

export default component.exports